import LogRocket from 'logrocket';

let hasStartedRecording = false;

import { DISABLE_LOGROCKET } from 'Config/constants'

export const initializeLogRocket = () => {
  if (!(DISABLE_LOGROCKET === 'true') && !hasStartedRecording) {
    LogRocket.init('dnunsn/ma-domiciliation', {
      // shouldRecord: () => false,
      network: {
        requestSanitizer: request => {
          if (
            request.url.toLowerCase().indexOf('api/login') !== -1
            || request.url.toLowerCase().indexOf('/password') !== -1
            || request.url.toLowerCase().indexOf('/new-password') !== -1
            || request.url.toLowerCase().indexOf('administrations/login') !== -1
            || request.url.toLowerCase().indexOf('/company-creation/onboarding') !== -1
          ) {
            request.body = 'hidden'
          }

          return request
        },
      },
    })

    hasStartedRecording = true
  }
};

// export const maybeStartRecordingLogrocket = () => {
//   if (!(DISABLE_LOGROCKET === 'true')) {
//     if (!hasStartedRecording) {
//       console.log('LogRocket is starting recording');
//       console.log(LogRocket)
//       console.log(LogRocket.start)
//       LogRocket.start();
//       hasStartedRecording = true;
//     }
//   }
// };